var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconControlBarHide = function SvgIconControlBarHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M15.93 3.128a.75.75 0 0 1 1.061 1.06l-1.879 1.878c1.478.946 2.519 2.117 3.12 2.915a1.51 1.51 0 0 1 0 1.838c-1.16 1.542-3.955 4.482-8.382 4.482a9.5 9.5 0 0 1-3.363-.61L3.91 17.27a.75.75 0 1 1-1.06-1.061l2.195-2.196-.002-.001 1.613-1.613.001.001 5.874-5.874 1.203-1.205h.002zM7.752 13.427a4.2 4.2 0 0 0 5.806-5.806zM9.85 4.5c.826 0 1.594.102 2.306.278l-1.059 1.058a4.2 4.2 0 0 0-5.13 5.13L3.773 13.16A12.5 12.5 0 0 1 1.47 10.82a1.51 1.51 0 0 1 0-1.838C2.629 7.44 5.424 4.501 9.85 4.5"
  })));
};
export default SvgIconControlBarHide;